// Modul belajar Bahasa Indonesia: teks informasi lalu teks fiksi, masing-masing diikuti modul
// subkompetensi TKA (kosakata, ikhtisar, fakta & opini, ungkapan, perubahan, menanggapi cerita).
import { MODUL_BI_INFORMASI } from './bi-informasi.js';
import { MODUL_BI_FIKSI } from './bi-fiksi.js';
import { MODUL_BI_KOMPETENSI_INFORMASI } from './bi-kompetensi-informasi.js';
import { MODUL_BI_KOMPETENSI_FIKSI } from './bi-kompetensi-fiksi.js';

export const MODUL_BI = [...MODUL_BI_INFORMASI, ...MODUL_BI_KOMPETENSI_INFORMASI, ...MODUL_BI_FIKSI, ...MODUL_BI_KOMPETENSI_FIKSI];
